<template>
    <DFormRow
        :label="__('customers.contracts.price')"
        :is-required="true"
        :error="errors.price"
    >
        <DInput
            :id="`price${idSuffix}`"
            :model-value="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'Price',
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        idSuffix: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue']
}
</script>
